import apiClient from "./apiClient";

const classLogApi = {
	createClassLogWithAbsences: async (classLogData, token) => {
		try {
			const response = await apiClient.post(
				"/ClassLog/create-with-absences",
				classLogData,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			);
			return response.data;
		} catch (error) {
			console.error(
				"API error in createClassLogWithAbsences:",
				error.response || error
			);
			throw error;
		}
	},

	updateClassLog: async (id, updatedLogData, token) => {
		try {
			const response = await apiClient.put(`/ClassLog/${id}`, updatedLogData, {
				headers: { Authorization: `Bearer ${token}` },
			});
			return response.data;
		} catch (error) {
			console.error("API error in updateClassLog:", error.response || error);
			throw error;
		}
	},

	getClassLogDetails: async (id, token) => {
		try {
			const response = await apiClient.get(`/ClassLog/details/${id}`, {
				headers: { Authorization: `Bearer ${token}` },
			});
			return response.data;
		} catch (error) {
			console.error(
				"API error in getClassLogDetails:",
				error.response || error
			);
			throw error;
		}
	},
};

export default classLogApi;
